import structureTypes from 'common/constants/structureTypes'
import EntityTypeEnum from 'common/enums/entityTypeEnum'

export const readOnlyRowEntities: Array<
  EntityTypeEnum | keyof typeof structureTypes
> = [EntityTypeEnum.ContactUs]
